


























import Vue from 'vue'
import LeftRight from './components/LeftRight.vue'
import LeftPosition from './components/LeftPosition.vue'
import OrganizationDetail from './components/OrganizationDetail.vue'
import {
  UserPostServiceProxy,
  UserOrganizationServiceProxy
} from '@/service-proxies/app-v2/user.service-proxies'

const upsp = new UserPostServiceProxy()
const uosp = new UserOrganizationServiceProxy()

export default Vue.extend({
  components: {
    LeftRight,
    OrganizationDetail,
    LeftPosition
  },
  data() {
    return {
      total: 0,
      current: 1,
      size: -1,
      filter: {
        keywords: '',
        postId: ''
      },
      dataSource: [],
      selectTab: '1',
      organizationId: ''
    }
  },
  methods: {
    changeCustomer(value) {
      this.organizationId = value
      if (value !== '' && this.selectTab == '1') {
        this.getData()
      }
    },
    changeTab(value) {
      this.selectTab = value
      this.filter.keywords = ''
    },
    changeKeys(keys) {
      this.filter.keywords = keys
    },
    reast() {
      if (this.selectTab == '2') {
        this.reloadData()
      } else {
        this.getData()
      }
    },
    async getData() {
      this.dataSource = []
      const filter: any = {
        keyValue: this.filter.keywords,
        organizationId: this.organizationId
      }
      const { data } = await uosp.getUsersForOrganization(1, filter, -1)
      if (data.records && data.records.length) {
        this.dataSource = data.records
      }
    },
    changePosition(value) {
      this.filter.postId = value.id
      this.reloadData()
    },
    async reloadData() {
      this.dataSource = []
      const filter: any = {
        keyValue: this.filter.keywords,
        postId: this.filter.postId
      }
      const { data } = await upsp.getUsersForPost(this.current, filter, this.size)
      if (data.records) {
        this.dataSource = data.records
      }
    }
  }
})
